const actionTypes = {
    REQUEST_PUBLICATIONS: 'REQUEST_PUBLICATIONS',
    RECEIVE_PUBLICATIONS_SUCCESS: 'RECEIVE_PUBLICATIONS_SUCCESS',
    RECEIVE_PUBLICATIONS_FAILURE: 'RECEIVE_PUBLICATIONS_FAILURE',

    REQUEST_PUBLICATION_FILTERS: 'REQUEST_PUBLICATION_FILTERS',
    RECEIVE_PUBLICATION_FILTERS_SUCCESS: 'RECEIVE_PUBLICATION_FILTERS_SUCCESS',
    RECEIVE_PUBLICATION_FILTERS_ERROR: 'RECEIVE_PUBLICATION_FILTERS_ERROR',

    EXPORT_PUBLICATIONS: 'EXPORT_PUBLICATIONS',
    EXPORT_PUBLICATIONS_SUCCESS: 'EXPORT_PUBLICATIONS_SUCCESS',
    EXPORT_PUBLICATIONS_FAILURE: 'EXPORT_PUBLICATIONS_FAILURE'
};

export default actionTypes;